module.exports = "../../../../platform/assets/pageMainIcon/baobiaochaxunlei1.svg";